import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '@environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.idp_issuer,
  clientId: environment.idp_client_id, // The "Auth Code + PKCE" client
  responseType: 'code',
  redirectUri: window.location.origin,
  postLogoutRedirectUri: window.location.origin,
  scope: 'openid profile email api entitlements offline_access', // Ask offline_access to support refresh token refreshes
  showDebugInformation: false, // Also requires enabling "Verbose" level in devtools
  strictDiscoveryDocumentValidation: false,
  //timeoutFactor: 0.01,
};
